<template>
  <div class="o-pagelayout" id="start">
    <div class="c-topbar" v-if="showToolbar">
      <div class="c-topbar__left">
        <mtg-header-link></mtg-header-link>
      </div>
      <div class="c-topbar__right">
        <div class="c-topbar__actions">
          <div class="c-topbar__action">
            <router-link :to="{ name: 'login' }" class="btn btn-outline-primary"> {{ $t("lang.label_signIn") }}</router-link>
          </div>
          <div class="c-topbar__action">
            <router-link :to="{ name: 'register' }" class="btn btn-primary"> {{ $t("lang.label_register") }}</router-link>
          </div>
        </div>
      </div>
    </div>
    <main class="o-main o-main--align-center o-main--no-topbar" id="main">
      <div class="c-bg-visual">
        <div class="c-bg-visual__alpha">
          <img class="c-bg-visual__alpha-img" src="images/layout/bg-visual-alpha.png" alt="" />
        </div>
        <div class="c-bg-visual__beta">
          <img class="c-bg-visual__beta-img" src="images/layout/bg-visual-beta.png" alt="" />
        </div>
      </div>
      <div class="o-main__content">
        <alert-modal v-if="showAlert" :showAlert="showAlert"></alert-modal>
        <slot />
      </div>
      <div v-if="showCookies && showToolbar">
        <b-toast id="cookies" visible variant="dark" toaster="b-toaster-bottom-left" no-auto-hide no-close-button>
          <h6>
            {{ $t("lang.label_cookies") }}
            <b-link :to="{ name: 'terms-conditions', params: { previousPage: 'login-and-registration' } }"
              ><u
                ><strong> {{ $t("lang.label_cookies_why") }}</strong></u
              ></b-link
            >
          </h6>
          <b-button class="btn-primary" @click="closeCookies">OK</b-button>
        </b-toast>
      </div>
    </main>
    <footer-component />
    <transition name="fade" mode="out-in">
      <loading-bar v-show="isLoading"></loading-bar>
    </transition>
  </div>
</template>
<script>
import AlertModal from "../components/AlertModal";
import FooterComponent from "../components/FooterComponent";
import LoadingBar from "@/components/LoadingBar";
import MtgHeaderLink from "../components/layout/MtgHeaderLink";

export default {
  name: "LoginAndRegistrationLayout",
  components: {
    MtgHeaderLink,
    AlertModal,
    FooterComponent,
    LoadingBar
  },
  props: {},
  methods: {
    closeCookies() {
      this.$store.dispatch("cookies/closeCookies");
      this.$bvToast.hide("cookies");
    }
  },
  computed: {
    showToolbar() {
      return this.$route.meta.showToolbar;
    },
    showCookies() {
      return this.$store.getters["cookies/firstVisit"];
    },
    showAlert() {
      return this.$store.getters["alert/showAlert"];
    },
    isLoading() {
      return this.$store.getters["isLoading"];
    }
  }
};
</script>
<style scoped>
.openModal {
  display: block;
}
.b-toast {
  max-width: 250px;
  margin-bottom: 3rem;
  margin-left: 1rem;
  opacity: 0.95;
}
</style>
